import React from 'react';
import moment from 'moment';
import {useInspectionResultHistory} from '../../hooks/useInspectionResultHistory';

const getAnswerLabels = field => {
  if (!field.answers || field.answers.length === 0) return [];
  return field.answers.map(answer => {
    const option = field.options?.find(o => o.value === answer);
    return option ? option.label : answer;
  });
};

const formatDate = dateStr => {
  if (!dateStr) return '';
  const date = moment(dateStr);
  const today = moment().startOf('day');
  const yesterday = moment().subtract(1, 'day').startOf('day');
  if (date.isSameOrAfter(today)) {
    return `Today, ${date.format('HH:mm')}`;
  } else if (date.isSameOrAfter(yesterday)) {
    return `Yesterday, ${date.format('HH:mm')}`;
  }
  return date.format('MMM DD, YYYY HH:mm');
};

const LogsModal = ({currentItem, onClose}) => {
  const {
    data: logsData,
    isLoading: logsIsLoading,
    isError: logsIsError,
  } = useInspectionResultHistory(currentItem?.result_id);

  return (
    <div className='modal'>
      <div className='modal__content modal__content--logs'>
        <div className='modal__content-head'>
          <p>Logs</p>
          <img
            className='modal__content-exit'
            src='/assets/icons/close.svg'
            alt='close'
            onClick={onClose}
          />
        </div>
        <div className='modal__content-body logs-modal__body'>
          {logsIsLoading && (
            <div className='logs-modal__state'>
              <span className='skeleton-loader'></span>
              <span className='skeleton-loader'></span>
              <span className='skeleton-loader'></span>
            </div>
          )}
          {logsIsError && (
            <div className='logs-modal__state logs-modal__state--error'>
              Failed to load logs. Please try again.
            </div>
          )}
          {!logsIsLoading &&
            !logsIsError &&
            (!logsData || logsData.length === 0) && (
              <div className='logs-modal__state logs-modal__state--empty'>
                No logs found for this category.
              </div>
            )}
          {!logsIsLoading && !logsIsError && logsData?.length > 0 && (
            <ul className='logs-modal__list'>
              {logsData.map((log, index) => (
                <li key={log.id ?? index} className='logs-modal__item'>
                  <div className='logs-modal__item-aside'>
                    <span className='logs-modal__item-dot' />
                    {index < logsData.length - 1 && (
                      <span className='logs-modal__item-line' />
                    )}
                  </div>
                  <div className='logs-modal__item-content'>
                    <div className='logs-modal__item-header'>
                      <span className='logs-modal__item-user'>
                        {log.submitted_by ??
                          log.user?.full_name ??
                          log.user?.name ??
                          log.created_by ??
                          'Unknown'}
                      </span>
                      <span className='logs-modal__item-date'>
                        {formatDate(log.created_at)}
                      </span>
                    </div>
                    {log.result?.map((field, fi) => {
                      const answerLabels = getAnswerLabels(field);
                      return (
                        <div key={fi} className='logs-modal__field'>
                          <span className='logs-modal__field-label'>
                            {field.label}:
                          </span>
                          <div className='logs-modal__field-badges'>
                            {answerLabels.map((label, li) => (
                              <span
                                key={li}
                                className='logs-modal__field-badge'
                              >
                                {label}
                              </span>
                            ))}
                          </div>
                          {field.comment_text && (
                            <p className='logs-modal__field-comment'>
                              {field.comment_text}
                            </p>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
      <div className='modal__bg' onClick={onClose}></div>
    </div>
  );
};

export default LogsModal;
